import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6d0d0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "flex transition-all duration-500 ease-in-out containerWidth moveIcons" }
const _hoisted_4 = { class: "relative ml-x4 w-full" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "border-b border-dashed border-mine-shaft h-1 absolute z-51 w-full"
}
const _hoisted_7 = {
  key: 0,
  class: "mr-x2 w-30 relative top-130",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "max-w-400" }
const _hoisted_9 = {
  key: 0,
  class: "mt-x5"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "c-magic-line c-magic-line--underline text-dusty-grey hover:text-mine-shaft" }
const _hoisted_14 = {
  key: 4,
  class: "flex flex-col gap-x3 mt-x3"
}
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = {
  key: 1,
  class: "ml-x4 absolute top-130 right-0",
  "aria-hidden": "true"
}
const _hoisted_17 = {
  key: 0,
  class: "w-full flex gap-4 justify-center items-center mt-x2",
  "aria-hidden": "true"
}

import { computed, ref, watch } from 'vue';
import { SwipeDirection, usePointerSwipe } from '@vueuse/core';
import { ProductTransparencyCategoryModel } from '@/types/productServerApi';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransparencySwipable',
  props: {
    categories: null,
    stepWidth: { default: '82vw' },
    containerWidth: { default: '100vw' },
    showNavigation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { categories: ProductTransparencyCategoryModel[], stepWidth: string, containerWidth: string, showNavigation?: boolean }

_useCssVars(_ctx => ({
  "7feb45c0": (props.stepWidth),
  "29989a1f": (props.containerWidth),
  "bd0b4f48": (__props.categories.length),
  "3aca19aa": (_unref(translateAmount))
}))



const labels = useBlockLabels();
const currentIndex = ref(0);
const translateAmount = computed(() => `translateX(calc(-${props.stepWidth} * ${currentIndex.value}))`);
const container = ref();
const { direction } = usePointerSwipe(container);
const showLeftNavigation = (index: number) => props.showNavigation && currentIndex.value > 0 && index === currentIndex.value;
const showRightNavigation = (index: number) => props.showNavigation && currentIndex.value < props.categories?.length - 1 && index === currentIndex.value;

watch(direction, (newDirection) => {
    if (newDirection) {
        swipe(newDirection);
    }
});

const swipe = (direction: SwipeDirection) => {
    if (direction === SwipeDirection.LEFT && currentIndex.value < props.categories?.length - 1) {
        currentIndex.value = currentIndex.value + 1;
    } else if (direction === SwipeDirection.RIGHT && currentIndex.value > 0) {
        currentIndex.value = currentIndex.value - 1;
    }
};

const navigateRight = () => {
    if (currentIndex.value < props.categories?.length - 1) {
        currentIndex.value = currentIndex.value + 1;
    }
};

const navigateLeft = () => {
    if (currentIndex.value > 0) {
        currentIndex.value = currentIndex.value - 1;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "relative w-full overflow-hidden container"
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(["mb-x6 ml-x4", {'ml-x8': __props.showNavigation}])
    }, [
      _createTextVNode(_toDisplayString(_unref(labels).title) + " ", 1),
      (_unref(labels).subTitle)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "o-text-body mt-x1",
            innerHTML: _unref(labels).subTitle
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: category.id,
            class: "stepWidth relative"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex items-center h-90 w-full pl-x4 overflow-hidden", {'pl-x8': __props.showNavigation}])
            }, [
              _createVNode(_component_ResponsiveImage, {
                "is-product-image": "",
                "aria-hidden": "true",
                class: "w-90 h-90 md:ml-12 overflow-hidden",
                mode: "contain",
                "image-url": category.logoImage?.path,
                alt: category.title,
                "aspect-ratio": 1/1,
                "width-on-screen": 1,
                "cache-bust": category.logoImage?.cacheBust
              }, null, 8, ["image-url", "alt", "cache-bust"]),
              _createElementVNode("div", _hoisted_4, [
                (index === __props.categories.length -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["pl-x4 flex relative", showLeftNavigation(index) ? 'pr-0' : 'pr-x4'])
            }, [
              (__props.showNavigation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", { onClick: navigateLeft }, [
                      _createVNode(_Transition, {
                        name: "o-anim-fade-300",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (showLeftNavigation(index))
                            ? (_openBlock(), _createBlock(_component_CIcon, {
                                key: 0,
                                name: "icon-arrow-slider",
                                class: "w-30 h-90 rotate-180"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                (category.header)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(category.header), 1))
                  : _createCommentVNode("", true),
                (category.title)
                  ? (_openBlock(), _createElementBlock("h4", {
                      key: 1,
                      class: _normalizeClass(["font-cormorant text-24 mb-x2 mt-x1", {'mt-x5': !category.header}])
                    }, _toDisplayString(category.title), 3))
                  : _createCommentVNode("", true),
                (category.description)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      innerHTML: category.description
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                (category.crossSectionDocumentUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: category.crossSectionDocumentUrl,
                        class: "block mt-x3"
                      }, [
                        _createVNode(_component_c_icon, {
                          name: "icon-pdf",
                          title: _unref(labels).crossSectionDocumentDownload,
                          class: "lg:-mt-3 mr-x1 text-dusty-grey hover:text-mine-shaft"
                        }, null, 8, ["title"]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(labels).crossSectionDocumentDownload), 1)
                      ], 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true),
                (category.specifications)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.specifications, (spec) => {
                        return (_openBlock(), _createElementBlock("dl", {
                          key: category.id + spec.key
                        }, [
                          _createElementVNode("dt", _hoisted_15, _toDisplayString(spec.key), 1),
                          _createElementVNode("dd", null, _toDisplayString(spec.value), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (showRightNavigation(index))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("button", { onClick: navigateRight }, [
                      _createVNode(_component_CIcon, {
                        name: "icon-arrow-slider",
                        class: "w-30 h-90"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    (__props.categories.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["h-8 w-8 rounded-full bg-wild-sand transition-colors duration-500 ease-in-out", {'bg-silver': index === currentIndex.value}])
            }, null, 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})